interface ConnectionEvent {
    event: string,
    listener: (data: any) => void
}

interface Data<T> {
    data: T
}

class ConnectionEventEmiter {
    private document: Document;

    constructor(document: any) {
        this.document = document;
    }

    subscribe(args: ConnectionEvent) {
        if (args.listener) {
            this.document.addEventListener(args.event, args.listener, { once: true });
        }
    }

    unsubscribe(args: ConnectionEvent) {
        this.document.removeEventListener(args.event, args.listener);
    }

    publish(eventName: string, data: Data<any>) {
        const event = new CustomEvent(eventName, { detail: data });
        document.dispatchEvent(event);
    }
}

export default ConnectionEventEmiter;